import { padCodes } from './mapEcoFormFields';

function medidaOuVazio(item) {
  return item.MEDIDA !== null && item.MEDIDA !== undefined ? item.MEDIDA : '';
}

// Só o estudo congênito. A cópia de laudo anterior não usa esta função:
// esses campos permanecem os do exame aberto.
export default function mapEcoCongenitoFields(source) {
  return {
    situs: padCodes(source.situs, i => i.CODSITUS, 5),
    septoIA: padCodes(source.septoIA, i => i.CODSEPTO, 5),
    medidaCIA: padCodes(source.septoIA, medidaOuVazio, 5),
    septoIV: padCodes(source.septoIV, i => i.CODSEPTO, 5),
    regiaoSeptoIV: padCodes(source.septoIV, i => i.CODREGIAO, 5),
    medidaCIV: padCodes(source.septoIV, medidaOuVazio, 5),
    diametroVSVD: source.DVSVD ?? '',
    gradienteVEVD: source.GVEVD ?? '',
    vtiPulmonar: source.VTIP ?? '',
    vtiVSVE: source.VTIVSVE4 ?? '',
    concordAV: padCodes(source.concordAV, i => i.CODCONCORDAV, 5),
    viaSaida: padCodes(source.ecoVS, i => i.CODVS, 5),
    concordVA: padCodes(source.concordVA, i => i.CODCONCORDVA, 5),
    arteriaPulmonar: padCodes(source.artP, i => i.CODARTP, 5),
    arteriaCoronaria: padCodes(source.artC, i => i.CODARTC, 5),
    arcoAortico: padCodes(source.arcoAO, i => i.CODARCOAO, 5),
    conexaoVenoAtrial: padCodes(source.conexao, i => i.CODCONEXAO, 5),
    estruturasAnomalas: padCodes(source.estrutura, i => i.CODESTRUTURA, 5),
  };
}
